/** @jsxImportSource @emotion/react */
import { ReactComponent as DepositOfflineIcon } from "assets/desktop/icons/transaction/deposit-offline.svg";
import { ReactComponent as DepositOnlineIcon } from "assets/desktop/icons/transaction/deposit-online.svg";
import { DepositType, OrderStatus, OrderType } from "enums/orders";
import { formatCurrency } from "helpers/formatCurrency";
import { showAmount, showStatusTransaction } from "helpers/showStatusText";
import moment from "moment";

import { ItemTransactionStyle } from "./index.style";

interface Props {
  title: string;
  createdDate: string;
  amount: string;
  type: DepositType | string;
  status: OrderStatus;
  orderType?: OrderType;
}

export const ItemTransaction: React.FC<Props> = ({
  title,
  createdDate,
  amount,
  type,
  status,
  orderType,
}) => {
  const showDepositType = (type: DepositType) => {
    switch (type) {
      case DepositType.OFFLINE:
        return (
          <>
            <DepositOfflineIcon /> <span>Offline</span>
          </>
        );
      case DepositType.ONLINE:
        return (
          <>
            <DepositOnlineIcon /> <span>Online</span>
          </>
        );
    }
  };
  const titleText = orderType === OrderType.REBATE ? type : title;

  return (
    <div css={ItemTransactionStyle.self}>
      <div css={ItemTransactionStyle.header}>
        <div css={ItemTransactionStyle.title}>{titleText}</div>
        <div css={ItemTransactionStyle.createdDate}>
          {moment(createdDate).isValid()
            ? moment(createdDate).format("DD/MM/YYYY")
            : createdDate}
        </div>
      </div>
      <div css={ItemTransactionStyle.data}>
        <div css={ItemTransactionStyle.amount}>
          {showAmount(orderType, formatCurrency(amount))} VND
        </div>
        <div css={ItemTransactionStyle.status(status)}>
          {showStatusTransaction(status)}
        </div>
        {OrderType.DEPOSIT && (
          <div css={ItemTransactionStyle.depositType}>
            {showDepositType(type as DepositType)}
          </div>
        )}
      </div>
    </div>
  );
};
